import { Analyse } from "../state/schema";
import { Store } from "../state/store";

export interface StepContext {
  store: Store;
  rerender(): void; // rendert den aktuellen Schritt neu (für bedingte Felder)
  goNext(): void;
  goPrev(): void;
  goTo(stepId: string): void;
  toast(msg: string): void;
}

export interface Step {
  id: string;
  section: string | null; // Abschnitts-ID; null = Willkommen/Erfolg (ohne Standard-Chrome)
  eyebrow?: string;
  title: string;
  subtitle?: string;
  chrome?: boolean; // default true
  build(ctx: StepContext): HTMLElement;
  validate?(s: Analyse): string[];
  /** Kurze positive Bestätigung beim Verlassen (Gamification). */
  leaveMessage?: string;
}

export interface SectionDef {
  id: string;
  label: string;
}

export const SECTIONS: SectionDef[] = [
  { id: "fundament", label: "Fundament" },
  { id: "absicherung", label: "Absicherung" },
  { id: "vermoegen", label: "Vermögen" },
  { id: "haushalt", label: "Haushaltscheck" },
  { id: "zukunft", label: "Zukunft" },
  { id: "abschluss", label: "Abschluss" },
];

export function sectionLabel(id: string | null): string {
  return SECTIONS.find((s) => s.id === id)?.label ?? "";
}
